/* Check Available Products in Wishlist and Update Wishlist IDs */
setInterval(updateWishlistIDS, 500);
function updateWishlistIDS() {
    let addAllButton = document.querySelector('#add-all-wishlist');
    let body = document.querySelector('body');
    let elements = document.querySelectorAll('.product-card[data-available="true"]');
    let ids = [];
    if( elements.length ){
        for (var i=0; i<elements.length; i++) {
            ids.push(elements[i].dataset.epi);
        }
        if( addAllButton ){
            addAllButton.dataset.wishlistIds = ids.join(',');
        }
        body.classList.remove('wishlist-add-all-unavailable');
        body.classList.add('wishlist-add-all-available');
    }else{
        if(addAllButton)
          addAllButton.dataset.wishlistIds = '';
        body.classList.remove('wishlist-add-all-available');
        body.classList.add('wishlist-add-all-unavailable');
    }
    // const wrapper = document.querySelector('.addAllWishlistWrapper');
    // if(!document.querySelector('.addAllWishlistWrapper p'))
    //   wrapper.innerHTML += '<p>Once you click “Add All to Cart,” please allow up to a minutes for it to load</p>';

// document.querySelector('.addAllWishlistWrapper').append('Your text here');
    
}


//Add all items from wishlist
document.addEventListener('click',function(e){
    if(e.target.id == 'add-all-wishlist'){
      console.log( addAllItems(e.target.dataset.wishlistIds) )
    }
});

function addAllItems(variantIdArray) {
    toggleLoader();
    //split fake liquid array to make proper array
    var newVariantIdArray = variantIdArray.split(',');

    //map over variant array to create an array of objects with quantity and id
    var product_data = newVariantIdArray.map(variantId => {
      return {quantity: 1, id: variantId}
    })

    //add the items to the data object we need to pass to the fetch call
    // (sections requested up front so the drawer can be rendered straight from this
    // response, the same way product-form.js does for a normal add to cart)
    var data = {
      items: product_data,
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    }

    fetch('/cart/add.js', {
      body: JSON.stringify(data),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With':'xmlhttprequest'
      },
      method: 'POST'
    }).then((response) => response.json()).then((cartResponse) => {
      removeItemsFromWishlist(cartResponse);
    }).catch((err) => {
      toggleLoader();
      console.error(err)
    });
}

//Check Lists
function removeItemsFromWishlist(cartResponse){
  window._swat.fetchLists({
    callbackFn: function(lists) {
      lists.forEach(list => { //Cycle through lists
        if(list.lname == 'Wishlist'){ //Find Wishlist
          removeProductsFromWishlist(list.lid, list.listcontents, cartResponse); //Pass list ID for removing products
        }
      });
    },
    errorFn: function(xhrObj) {
      toggleLoader();
    }
  });
}

function chunkArray(array, chunkSize) {
    const result = [];
    for (let i = 0; i < array.length; i += chunkSize) {
        result.push(array.slice(i, i + chunkSize));
    }
    return result;
}

//Use list ID to remove products related products from Wishlist
async function removeProductsFromWishlist(lid, listcontents, cartResponse){
  var allAvailableWishlistItems = document.querySelector('#add-all-wishlist').dataset.wishlistIds.split(',');

  //Build an array of List Item Input based on available products.
  var listItemMaps = [];
  listcontents.forEach(item => {
    if( allAvailableWishlistItems.includes((item.epi).toString()) ){
      listItemMaps.push({
        epi: item.epi,
        empi: item.empi,
        du: item.du,
        qty: 1
      });
    }
  });

  
  // Check for AutoDonation
  if (typeof window.runAutoDonation === 'function') {
    await window.runAutoDonation();
  }

  //Remove products from Wishlist
  toggleLoader();

  // Let the React wishlist grid drop these cards immediately instead of waiting for a reload.
  window.dispatchEvent(
    new CustomEvent('wishlist:items-removed', {
      detail: { epis: listItemMaps.map((item) => item.epi) },
    })
  );

  const chunkedWishlist = chunkArray(listItemMaps, 10);
  for (const wishlistItems of chunkedWishlist) {
    try {
      window._swat.removeProductsFromList(lid, wishlistItems, function(resp){
        console.log(wishlistItems)
      }, function(xhrObject) {
        console.log('test')
        console.log(xhrObject)
      })
    }catch (error) {
      console.log('Error occurred:', error);
    }
  }

  openCartDrawerOrRedirect(cartResponse);
}

// Desktop: open the slide-out cart drawer with the freshly-added items.
// Mobile (or if no drawer is present on the page): fall back to the cart page.
function openCartDrawerOrRedirect(cartResponse) {
  const isDesktop = window.matchMedia('(min-width: 990px)').matches;
  const cartDrawer = document.querySelector('cart-drawer');

  if (isDesktop && cartDrawer && typeof cartDrawer.renderContents === 'function' && cartResponse && cartResponse.sections) {
    cartDrawer.renderContents(cartResponse);
    return;
  }

  window.location.href = '/cart';
}